let features = "1";
let app_id = process.env.REACT_APP_ID;
let app_version = "2.0.6002.20260202";
let device_os = "web";

const templateBgColors = {
  book_demo:
    "linear-gradient(90deg, rgba(252,52,83,1) 0%, rgba(252,95,78,1) 21%, rgba(252,191,69,1) 100%);",
  get_quote:
    "linear-gradient(90deg, rgba(252,52,83,1) 0%, rgba(78,252,241,1) 0%, rgba(182,69,252,1) 80%);",
  submit_information:
    "linear-gradient(90deg, rgba(252,52,83,1) 0%, rgba(78,248,252,1) 0%, rgba(252,71,69,1) 80%);",
  event_registration:
    " linear-gradient(90deg, rgba(252,52,83,1) 0%, rgba(252,78,234,1) 0%, rgba(252,191,69,1) 80%);",
};

export { templateBgColors, app_id, app_version, features, device_os };
